import { ForwardedRef, forwardRef } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { DurationInput, DurationInputProps } from "../forms/duration-input";
import { FormField, FormFieldProps } from "./form-field";

export type DurationInputFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<FormFieldProps<TFieldValues, TFieldPath>, "children"> &
  Pick<DurationInputProps, "defaultUnit" | "allowedUnits" | "readOnly">;

export const DurationInputFormField = forwardRef(
  function DurationInputFormField<
    TFieldValues extends FieldValues = FieldValues,
    TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  >(
    props: DurationInputFormFieldProps<TFieldValues, TFieldPath>,
    ref: ForwardedRef<HTMLInputElement>,
  ) {
    return (
      <FormField {...props}>
        {(field) => (
          <DurationInput
            ref={ref}
            {...field}
            required={props.required}
            readOnly={props.readOnly}
            defaultUnit={props.defaultUnit}
            allowedUnits={props.allowedUnits}
          />
        )}
      </FormField>
    );
  },
);
